import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import leftLogo from '../img/rps_logo.png';
import rightLogo from '../img/madeby_logo.svg';

const Header = ({ title }) => {
  const theme = useTheme();

  return (
    <Box
      display="flex"
      flexDirection="column"
      py={2}
      px={2}
      mb={4}
      sx={{
        backgroundColor: theme.palette.background.default,
      }}
    >
      {/* Top Row: Logos */}
      {/* <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
        <img src={leftLogo} alt="Left Logo" style={{ height: 40 }} />
        <img src={rightLogo} alt="Right Logo" style={{ height: 40 }} />
      </Box> */}

      {/* Bottom Row: Title */}
      <Box display="flex" justifyContent="center" alignItems="center">
        <Typography
          variant="h4"
          align="center"
          sx={{
            fontFamily: theme.typography.fontFamily,
            color: theme.palette.text.white,
            fontWeight: 'bold',
          }}
        >
          OCAT {title}
        </Typography>
      </Box>
    </Box>
  );
};

export default Header;